import $ from 'jquery';

class VideoBanner {
    constructor(mobileBreakpoint) {
        this.mobileBreakpoint = mobileBreakpoint;
        this.$jsYoutubePlayer = $('#js-player');
        this.$videoWrapper    = $('.js-video-container');
        this.$window          = $(window);
        this.videoID          = this.$videoWrapper.data('video-id');

        if (this.$jsYoutubePlayer.length) {
            // Create script tag.
            const tag = document.createElement('script');
            tag.src   = 'https://www.youtube.com/iframe_api';

            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // Callback function for YouTube iframe API at window level.
            window.onYouTubeIframeAPIReady = () => {
                window.player = new YT.Player('js-player', {
                    videoId: this.videoID,
                    events: {
                        'onReady': VideoBanner.onPlayerReady,
                        'onStateChange': VideoBanner.pauseVideo
                    }
                });
            };

            $(window).on('keydown', (e) => {
                if (e.which === 27) {
                    this.pauseOnEsc();
                }
            });
        }
    }

    // Handle player ready, start video.
    static onPlayerReady(event) {
        $('.js-play-button').on('click', () => {
            event.target.playVideo();
            console.log('inner function', 'inner function');
            $('.js-video-background').hide();
        });
    }

    static pauseVideo(event) {
        $('.js-banner-close').on('click', () => {
            event.target.pauseVideo();
        });
    }

    pauseOnEsc() {
        window.player.pauseVideo();
    }
}

export default VideoBanner;
